import { Suspense } from 'react';

import { createFileRoute, redirect } from '@tanstack/react-router';

import { Container, Skeleton } from '@mui/material';

import { BusinessPage } from './BusinessPage';

export const Route = createFileRoute(
	'/_authenticated/claim/$claimId/_claim/business/',
)({
	beforeLoad: ({ context }) => {
		if (!context.user?.permissions.includes('claim.questionnaire.view')) {
			throw redirect({
				to: '/',
			});
		}
	},
	component: function ClaimBusinessPage() {
		return (
			<Container maxWidth="md" sx={{ marginLeft: 0 }}>
				<Suspense fallback={<Skeleton width={600} height={90} />}>
					<BusinessPage />
				</Suspense>
			</Container>
		);
	},
	head: (ctx) => ctx.match.context.setTitle('Claim', 'Questionnaire'),
});
